import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main className="max-w-3xl mx-auto px-6 py-20 text-gray-900" data-testid="not-found-page">
      <p className="text-sm text-gray-600 mb-4" data-testid="not-found-code">404</p>
      <h1 className="text-4xl font-extrabold mb-6" data-testid="not-found-heading">Page not found</h1>
      <p className="mb-8" data-testid="not-found-description">This page may have moved. Our repair team can still help with your printer.</p>
      <Link to="/" className="inline-block bg-gray-900 text-white px-6 py-3" data-testid="not-found-home-link">View repair services</Link>
    </main>
  );
}